<div class="flex items-center gap-[10px] w-[149px]" id="mach-core-header-logo">
  <a
    #logoElement
    id="header-first-focusable"
    [attr.href]="
      isBusiness ? content.logo.businessLogoUrl : content.logo.mainLogoUrl
    "
    [attr.target]="
      (
        isBusiness
          ? content.logo.businessLogoNewTab
          : content.logo.mainLogoNewTab
      )
        ? '_blank'
        : '_self'
    "
    data-acdl-action="header:delta logo"
    data-acdl-name="delta logo"
    data-acdl-page-section="header:delta logo"
    (click)="analyticsEventEmit(logoElement); (true)"
  >
    <img
      [attr.alt]="
        isBusiness
          ? content.logo.businessLogoAltText
          : content.logo.mainLogoAltText
      "
      [attr.src]="
        (isBusiness ? content.logo.businessLogo : content.logo.mainLogo) ||
        fallbackImage
      "
      width="119"
      height="19"
      [ngClass]="{
        'min-w-[150px] w-[150px]':
          mobileDarkSiteLogo.isEnabled === 'true' &&
          mobileDarkSiteLogo.level === 'level0'
      }"
      (click)="!(mobileDarkSiteLogo.isEnabled === 'true') && homeClicked()"
    />
  </a>
  <a
    role="button"
    tabindex="0"
    [attr.aria-label]="content.logo.subLogoAltText || 'Open sub logo link'"
    #triggerElement
    *ngIf="content.logo.subLogo && !isBusiness"
    data-acdl-action="header:sub logo"
    data-acdl-name="sub logo"
    data-acdl-page-section="header:sub logo"
    (click)="
      open(content.logo.subLogoUrl, content.logo.subLogoExtLinkPopup);
      analyticsEventEmit(triggerElement)
    "
    (keydown.enter)="
      open(content.logo.subLogoUrl, content.logo.subLogoExtLinkPopup);
      analyticsEventEmit(triggerElement)
    "
    (keydown.space)="
      open(content.logo.subLogoUrl, content.logo.subLogoExtLinkPopup);
      analyticsEventEmit(triggerElement);
      $event.preventDefault()
    "
    aria-haspopup="true"
    class="mr-0"
    href="javascript:void(0);"
    id="mach-core-header-sublogo-link"
  >
    <img
      [attr.alt]="content.logo.subLogoAltText"
      [attr.src]="content.logo.subLogo || fallbackImage"
      width="24"
      height="24"
      class="min-w-[24px]"
    />
  </a>
</div>
